import type { Enums } from "../types";

export function getPartnerAgreementTypeUnit(
	type: Enums<"organizationPartnershipAgreementType">,
): Enums<"unit"> | null {
	switch (type) {
		case "hourly-rate":
			return "currency";
		case "payment-target":
			return "days";
		case "early-payment-discount":
			return "percent";
		case "early-payment-discount-payment-target":
			return "days";
		default:
			return null;
	}
}
